import React from "react";
import { Icon } from "~/components/Icon";
import { TouchableOpacity } from "~/components/TouchableOpacity";
import type { ViewProps } from "~/components/View";
import { View } from "~/components/View";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import type { ReactNode } from "react";

interface CheckBoxProps {
  size?: number;
  checked: boolean;
  children?: ReactNode;
  style?: ViewProps["style"];
  onChange: (isChecked: boolean) => any;
}

export function CheckBox({
  checked,
  size = 20,
  style,
  children,
  onChange,
}: CheckBoxProps) {
  return (
    <TouchableOpacity
      onPress={() => {
        onChange(!checked);
      }}
    >
      <View flexDirectionRow alignItemsCenter style={style}>
        <Icon
          size={size}
          name={checked ? "checkbox-marked-outline" : "checkbox-blank-outline"}
          color={
            checked ? styleConstantsV2.colorBlack : styleConstantsV2.colorGrey
          }
        />
        {children}
      </View>
    </TouchableOpacity>
  );
}
